import React from "react";
import { useIntl } from "react-intl";
import { SpatialCarousel } from "@src/lms/jelly/extensions/layouts";

import { messages } from "../../Production.messages";
import styles from "./Slide2.module.scss";
import { SimpleLayoutView } from "@src/lms/jelly/extensions/layouts/simple/SimpleLayoutView";
import { useBlocks } from "@jelly/lesson";
import config from "appConfig";

export const Slide2: React.FC = () => {
  const { formatMessage } = useIntl();
  const block = useBlocks();

  return (
    <SimpleLayoutView>
      <div className={styles.root}>
        <div className={styles.rightComponent}>
          {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
          <SpatialCarousel showBreadcrumbs>
            {[
              <div key={1} className={styles.carouselItem}>
                <h3>{formatMessage(messages.G6_P4_S2_S1_Title)}</h3>
                <p>{formatMessage(messages.G6_P4_S2_S1_Description)}</p>
                <block.image src={`${config.STATIC_ASSETS_URL}/lms/guide/guide06/en/production_loop.svg`}></block.image>
              </div>,
              <div key={2} className={styles.carouselItem}>
                <h3>{formatMessage(messages.G6_P4_S2_S2_Title)}</h3>
                <p>{formatMessage(messages.G6_P4_S2_S2_Description1)}</p>
                <ul>
                  <li>{formatMessage(messages.G6_P4_S2_S2_Item1)}</li>
                  <li>{formatMessage(messages.G6_P4_S2_S2_Item2)}</li>
                  <li>{formatMessage(messages.G6_P4_S2_S2_Item3)}</li>
                  <li>{formatMessage(messages.G6_P4_S2_S2_Item4)}</li>
                  <li>{formatMessage(messages.G6_P4_S2_S2_Item5)}</li>
                </ul>
                <p>{formatMessage(messages.G6_P4_S2_S2_Description2)}</p>
              </div>,
            ]}
          </SpatialCarousel>
        </div>
      </div>
    </SimpleLayoutView>
  );
};
